<template>
    <div class="has-text-white">
        <table>
            <tr>
                <td>
                    <ad :specific="ind"></ad>
                </td>
                <td style="vertical-align: top !important; padding-left: 10px">
                    <div><b>{{item.title}}</b></div>
                    <div class="is-size-4">Impressions: <b>{{item.impressions}} &nbsp;<button class="button is-coolGreen top10 xs" @click="detail('imp')">Detail</button></b></div>
                    <div class="is-size-4">Clicks: <b>{{item.clicks}} &nbsp;<button class="button is-coolGreen top10 xs" @click="detail('clk')">Detail</button></b></div>
                    
                </td>
            </tr>
        </table>
       
        
    </div>

</template>

<script>

import Ad from './Ad'

export default {
    props: {
        item: {
            type: Object
        },
        ind: {
            type: Number
        }
    },
    components: {Ad},
    data: function(){
        return {
           
        }
    },
    mounted: function(){

    },

    methods: {
        detail: function(kind){
            this.$root.app.doShowModal('MetricsDetail', {id: this.item.id, metric: kind})
        }
    }
}
</script>